import { makeStyles, theme } from 'cdh-data-portal-theme'

export const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    height: 64,
    border: 0,
    background: 'transparent',
    gap: 20,
    padding: '0 28px',
    cursor: 'pointer',
    font: 'inherit',
    textAlign: 'left',
    textDecoration: 'none',
    color: theme.textColors.primary,
    overflow: 'hidden',
  },
  active: {
    color: theme.colors.primary,
  },
  indicator: {
    position: 'absolute',
    left: 0,
    top: 8,
    height: 48,
    width: 4,
    borderRadius: 2,
    backgroundColor: theme.colors.primary,
  },
  label: {
    '&&': {
      fontSize: 13,
    },
  },
}))
